import React, { useCallback, useMemo } from 'react'
import { useSelector } from 'react-redux'

import CampaignForm from './CampaignForm'
import AssetGroupCreative from './AssetGroupCreative'
import CampaignDetailsForm from './CampaignDetailsForm'
import AdCreativeForm from './AdCreative'

import useContinuousForm from '../../../../hooks/formHooks/useContinuousForm'

import { checkIfCampaignHasLineItem } from '../../CampaignForms/helpers'
import { insertIf } from '../../../../helpers/common'

import { googleRightUploadAdDataSelector } from '../../../../modules/selectors/rights'

export const CAMPAIGN_FORM = 'campaign_form'
export const CAMPAIGN_DETAILS_FORM = 'campaign_details_form'
export const AD_FORM = 'ad_form'
export const LINE_ITEM_FORM = 'line_item_form'

const UploadGoogleAdCreativeForm = ({ onSuccessSubmit }) => {
  const { campaign } = useSelector(googleRightUploadAdDataSelector)

  const { activatedForm, setActivatedForm } = useContinuousForm({
    initialForm: CAMPAIGN_FORM
  })

  const campaignHasLineItem = checkIfCampaignHasLineItem(campaign?.advertising_channel_type)

  const formProgressItems = useMemo(
    () => [
      {
        label: 'Campaign',
        isActive: activatedForm === CAMPAIGN_FORM || activatedForm === CAMPAIGN_DETAILS_FORM,
        isSuccess: activatedForm === AD_FORM || activatedForm === LINE_ITEM_FORM
      },
      ...insertIf(campaignHasLineItem, {
        label: 'Ad group',
        isActive: activatedForm === LINE_ITEM_FORM,
        isSuccess: activatedForm === AD_FORM
      }),
      {
        label: 'Creative assets',
        isActive: activatedForm === AD_FORM,
        isSuccess: false
      }
    ],
    [activatedForm, campaignHasLineItem]
  )

  const getActivatedForm = useCallback(() => {
    switch (activatedForm) {
      case CAMPAIGN_DETAILS_FORM:
        return (
          <CampaignDetailsForm
            onSuccessSubmit={() => setActivatedForm(campaignHasLineItem ? LINE_ITEM_FORM : AD_FORM)}
            formProgressItems={formProgressItems}
          />
        )
      case CAMPAIGN_FORM:
        return (
          <CampaignForm
            formProgressItems={formProgressItems}
            onSuccessSubmit={() => setActivatedForm(CAMPAIGN_DETAILS_FORM)}
            // when existing campaign was selected skip the CAMPAIGN_DETAILS_FORM and start with ad create
            onSelectExistingCampaign={() => setActivatedForm(campaignHasLineItem ? LINE_ITEM_FORM : AD_FORM)}
          />
        )
      default:
        if (campaignHasLineItem) {
          return (
            <AdCreativeForm
              activatedForm={activatedForm}
              setActivatedForm={setActivatedForm}
              onSuccessSubmit={onSuccessSubmit}
              formProgressItems={formProgressItems}
            />
          )
        } else {
          return <AssetGroupCreative onSuccessSubmit={onSuccessSubmit} formProgressItems={formProgressItems} />
        }
    }
  }, [activatedForm, formProgressItems, setActivatedForm, campaignHasLineItem, onSuccessSubmit])

  return <>{getActivatedForm()}</>
}

export default UploadGoogleAdCreativeForm
